import React from 'react'
import { AuthenticatedRoutesWrapper } from '@elrondnetwork/dapp-core'
import { useLocation } from 'react-router-dom'
import routes, { routeNames } from 'routes'

const Layout = ({ children }: { children: React.ReactNode }) => {
    const { search } = useLocation()
    return (
        <div className="wrapper">
            <main className="main-page-container">
                <AuthenticatedRoutesWrapper
                    routes={routes}
                    unlockRoute={`${routeNames.unlock}${search}`}
                >
                    {children}
                </AuthenticatedRoutesWrapper>
            </main>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '2vh',
                    marginBottom: '1vh',
                }}
            >
                <iframe
                    title="Elrond Community"
                    src="https://egld.community/api/products/94f233fa-77f6-4c70-9747-b5218fe8bc53/upvotes/embed"
                    width="290"
                    height="70"
                    style={{
                        borderRadius: '8px',
                        border: 'none',
                        width: 290,
                        height: 70,
                    }}
                />
            </div>
        </div>
    )
}

export default Layout
